import axios from "axios";
import { get } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useEffect, useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import { KEYS, PAYMENT_STATUS } from "utils/constants";
import Loading from "../Components/Spin";
import Template from "../Template";
import View from "./View";

const BankCard = ({
  currentStatus,
  tracer,
  project,
  onBack,
  onNext,
  updateUrl,
}) => {
  const [loading, setLoading] = useState(true);
  const [initializing, setInitializing] = useState(true);
  const [updateProject] = useMutation(UPDATE_PROJECT);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (get(project, "fields.paymentStatus") === PAYMENT_STATUS.PAID) {
      const source = localStorage.getItem(KEYS.SOURCE);
      updateUrl({
        subscriptionId,
        url: get(
          data,
          "subscription.insurancePlan.config.generatedUrl",
          `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
        ),
      });
      onNext({
        payload: {},
      });
    } else {
      setInitializing(false);
    }
  }, []);

  const initiatePayment = async () => {
    setIsRedirecting(true);

    try {
      const source = localStorage.getItem(KEYS.SOURCE);
      const response = await axios.post(
        `${process.env.REACT_APP_REST_BFF_URL.replace(
          "graphql",
          "",
        )}hooks/webhooks/request-payment`,
        {
          amount: Math.round(totalAmount * 100),
          transactionKey: get(project, "id"),
          returnContext: `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
        },
      );
      updateProject({
        variables: {
          where: { id: get(project, "id") },
          data: {
            fields: {
              ...get(project, "fields", {}),
              paymentStatus: PAYMENT_STATUS.PENDING,
            },
          },
        },
      });
      redirectToPayment(
        response.data.redirectionUrl,
        response.data.redirectionData,
      );
    } catch (error) {
      console.error("Payment failed:", error);
      setIsRedirecting(false);
    }
  };

  const redirectToPayment = (url, data) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    // form.target = "_blank";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "redirectionData";
    input.value = data;

    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  };

  const subscriptionId =
    get(project, "fields.currentSubscription") ||
    localStorage.getItem(KEYS.SUBSCRIPTION_ID);

  const [updateSubscription] = useMutation(
    graphql.mutations.UPDATE_SUBSCRIPTION,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: subscriptionId } },
        },
      ],
    },
  );

  const { data } = useQuery(graphql.queries.SUBSCRIPTION, {
    fetchPolicy: "no-cache",
    variables: { where: { id: subscriptionId } },
    onCompleted: ({ subscription }) => {
      getGeneralCost({
        variables: {
          where: {
            project: { id: get(project, "id") },
            insurancePlan: {
              id: get(subscription, "insurancePlan.id"),
            },
          },
        },
      });
    },
  });

  const [getGeneralCost, { loading: costLoading }] = useLazyQuery(
    graphql.queries.GENERAL_COST,
    {
      fetchPolicy: "no-cache",
      onCompleted: ({ generalCost }) => {
        const modules =
          get(
            project,
            `fields.upsells.${get(data, "subscription.insurancePlan.id")}`,
            [],
          ) || [];
        const totalCost = modules.reduce(
          (acc, { cost }) => (acc += cost),
          get(generalCost, "cost", 0),
        );
        setTotalAmount(totalCost);
        setLoading(false);
      },
    },
  );

  const initialValues = {
    additionalInfo: {
      bankCard: {
        ...get(
          omitDeep(data, "__typename"),
          "subscription.additionalInfo.bankCard",
        ),
      },
    },
  };

  const onSubmit = ({ additionalInfo: { bankCard } }) => {
    const subscriptionData = omitDeep(get(data, "subscription"), "__typename");
    setLoading(true);
    updateSubscription({
      variables: {
        where: {
          id: subscriptionId,
        },
        data: {
          additionalInfo: {
            ...get(subscriptionData, "additionalInfo", {}),
            bankCard: {
              ...get(subscriptionData, "additionalInfo.bankCard", {}),
              ...bankCard,
            },
          },
        },
      },
      onCompleted: () => {
        setLoading(false);
        onNext({
          payload: {},
        });
      },
    });
  };

  if (costLoading || !totalAmount || initializing) return <Loading />;

  return (
    <Template
      progress={currentStatus.progress}
      // onBack={onBack}
      loading={loading}
      HeaderComponent={null}
      hideEditButton={true}
      View={
        <View
          initialValues={initialValues}
          locked={get(data, "subscription.locked", false)}
          onSubmit={onSubmit}
          onBack={onBack}
          initiatePayment={initiatePayment}
          isRedirecting={isRedirecting}
          totalCost={totalAmount}
        />
      }
      contact={get(project, "contact")}
    />
  );
};
export default BankCard;
